<div class="flex-static-map">
    <div #mapTarget class="map-target" role="img" [attr.aria-label]="ariaLabel" [hidden]="!hasCoordinates"></div>
    <div *ngIf="!hasCoordinates" class="map-unavailable">{{ unavailableText }}</div>
    <ng-container *ngIf="hasCoordinates">
        <app-loader [isLoading]="isLoading"></app-loader>
        <div *ngIf="hasError" class="map-warning" aria-live="polite">
            <span>{{ 'DIAGNOSTICS.FLEX_MONITOR_STATUS.MAP_ERROR' | translate }}</span>
            <button mat-button type="button" (click)="retry()">
                {{ 'DIAGNOSTICS.FLEX_MONITOR_STATUS.RETRY' | translate }}
            </button>
        </div>
    </ng-container>
</div>
